// extracted by mini-css-extract-plugin
module.exports = {"auto_box":"auto_box-3jYt6hkD"};